module.exports = __webpack_public_path__ + "img/ai-card-img2.4d674b0d.png";